import React, { useEffect, useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { API_WEB_URLS } from "constants/constAPI"
import { Fn_AddEditData, Fn_FillListData, Fn_GetReport } from "store/Functions"
import { Col, Row } from "reactstrap"
import "react-toggle/style.css"  
import ReactToggle from "react-toggle" 

const AddEdit_SalesPersonStock = () => {
  const API_URL = API_WEB_URLS.MASTER + "/0/token/Sales"
  const API_URL1 = API_WEB_URLS.MASTER + "/0/token/Product"
  const API_URL2 = API_WEB_URLS.MASTER + "/0/token/ItemType"
  const API_URL3 = API_WEB_URLS.MASTER + "/0/token/Weight"
  const API_URL_SAVEH = "TransactionH/0/token"
  const API_URL_Item = "GetRemainingStockPacked/0/token"
  const API_URL_SAVEL = "TransactionL/0/token"
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/ProductRateEdit/Id"

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    FillArray1: [],
    FillArray2: [],
    FillArray3: [],
    formData: {
      F_SaleMaster: -1,
      VoucherDate: new Date().toISOString().split("T")[0], 
      IsInOut : false,
    },
    isProgress: true,
  })

  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const [rows, setRows] = useState([{ F_ItemMaster: "",F_BrandMaster:-1,F_WeightCategory:-1, Quantity: 1 }])

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0")
    // Fn_FillListData(dispatch, setState, "FillArray1", API_URL1 + "/Id/0")
    Fn_FillListData(dispatch, setState, "FillArray2", API_URL2 + "/Id/0")
    Fn_FillListData(dispatch, setState, "FillArray3", API_URL3 + "/Id/0")

    const Id = (location.state && location.state.Id) || 0

    if (Id > 0) {
      setState(prevState => ({
        ...prevState,
        id: Id,
      }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [dispatch, location.state])

  const handleSalespersonChange = event => {
    setState(prevState => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        F_SaleMaster: event.target.value,
      },
    }))
  }

  const handleDateChange = event => {
    setState(prevState => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        VoucherDate: event.target.value,
      },
    }))
  }

  const handleAddRow = () => {
    setRows([...rows, { F_BrandMaster : -1,F_WeightCategory:-1,F_ItemMaster: "", Quantity: 1 }])
  }

  const handleDeleteRow = index => {
    setRows(rows.filter((_, rowIndex) => rowIndex !== index))
  }

  const handleRowChange = (index, event) => {
    const { name, value } = event.target
    const updatedRows = [...rows]
    updatedRows[index][name] = value
    if(updatedRows[index].F_BrandMaster >0 && updatedRows[index].F_WeightCategory > 0 && name =='F_WeightCategory'){
      let vformData = new FormData();
      vformData.append("F_BrandMaster", updatedRows[index].F_BrandMaster);
      vformData.append("F_WeightCategory", updatedRows[index].F_WeightCategory);
      
      Fn_GetReport(dispatch, setState, "ItemArray", API_URL_Item,  { arguList: { id: 0, formData: vformData }}, true,index,state.FillArray1,'FillArray1');
    }
    if(updatedRows[index].F_ItemMaster>0 && name=='Quantity'){
      
      let obj = state.FillArray1[index].find((item,i)=>item.Id == updatedRows[index].F_ItemMaster )
      if(obj.Quantity < value){
        updatedRows[index][name] = 0
        alert(`Quantity is not sufficient available : ${obj.Quantity}`)
      }
    }
    setRows(updatedRows)
  }
  const handleToggleChange = () => {
    setState(prevState => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        IsInOut: !prevState.formData.IsInOut,  // Toggle between In (false) and Out (true)
      },
    }))
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log({
      F_SaleMaster: state.formData.F_SaleMaster,
      VoucherDate: state.formData.VoucherDate,
      rows,
    })

    const obj = JSON.parse(localStorage.getItem("authUser"));
    let  F_SaleTransactionH = 0
    const formData = new FormData();
    formData.append("F_SaleMaster",state.formData.F_SaleMaster);
    formData.append("VoucherDate", state.formData.VoucherDate);
    formData.append("IsInOut", state.formData.IsInOut);
    
    try {
      const response = await Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVEH,
        true,
        "memberid"
      );
  
      if(response && response.id)
      {
        F_SaleTransactionH = response.id

        const formData1 = new FormData();
        formData1.append("F_SaleTransactionH", F_SaleTransactionH);
        formData1.append("Data", JSON.stringify(rows) );
        
        await Fn_AddEditData(
          dispatch,
          setState,
          { arguList: { id: 0, formData : formData1 } },
          API_URL_SAVEL,
          true,
          "memberid",
          navigate,
          '#'
        );

        window.location.reload()
      }
 
    } catch (error) {
      console.error("Error submitting data:", error);
    }

    
  }

  return (
    <div className="page-content">
      <form onSubmit={handleSubmit} className="border p-4 rounded bg-light">
        <Row>
          <Col lg='2'>
            <label className="form-label">Select Salesperson:</label>
          </Col>
          <Col lg='4'>
            <select
              value={state.formData.F_SaleMaster}
              onChange={handleSalespersonChange}
              className="form-select"
              required
            >
              <option value="">Select</option>
              {state.FillArray.length > 0 &&
                state.FillArray.map(person => (
                  <option key={person.Id} value={person.Id}>
                    {person.Name}
                  </option>
                ))}
            </select>
           
          </Col>
          <Col lg='2'>
            <label className="form-label">Date:</label>
          </Col>
          <Col lg='4'>
            <input
              type="VoucherDate"
              value={state.formData.VoucherDate}
              onChange={handleDateChange}
              className="form-control"
              required
            />
          </Col>
        </Row>
        <Row className="mt-4">
  <Col lg="2">
    <label className="form-label">In/Out:</label>
  </Col>
  <Col lg="4" className="d-flex align-items-center">
    <ReactToggle
      checked={state.formData.IsInOut}
      onChange={handleToggleChange}
      // icons={{ checked: 'Out', unchecked: 'In' }}
    />
    <strong className="ms-2"> {state.formData.IsInOut ? 'Out' : 'In'}</strong>  {/* Add ms-2 for spacing */}
  </Col>
</Row>

        <table className="table table-bordered mt-4">
          <thead className="table-dark">
            <tr>
              <th>Brand</th>
              <th>Weight Category</th>
              <th>Product</th>
              <th>Quantity {"(No's)"}</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  <select
                    name="F_BrandMaster"
                    value={row.F_BrandMaster}
                    onChange={e => handleRowChange(index, e)}
                    className="form-select"
                    required
                  >
                    <option value="">Select Brand</option>
                    {state.FillArray2.length > 0 &&
                      state.FillArray2.map(product => (
                        <option key={product.Id} value={product.Id}>
                          {product.Name}
                        </option>
                      ))}
                  </select>
                </td>
                <td>
                  <select
                    name="F_WeightCategory"
                    value={row.F_WeightCategory}
                    onChange={e => handleRowChange(index, e)}
                    className="form-select"
                    required
                  >
                    <option value="">Select Weight Category</option>
                    {state.FillArray3.length > 0 &&
                      state.FillArray3.map(product => (
                        <option key={product.Id} value={product.Id}>
                          {product.Name}
                        </option>
                      ))}
                  </select>
                </td>
                <td>
                  <select
                    name="F_ItemMaster"
                    value={row.F_ItemMaster}
                    onChange={e => handleRowChange(index, e)}
                    className="form-select"
                    required
                  >
                    <option value="">Select Product</option>
                    {state.FillArray1.length > 0 && state.FillArray1[index] &&
                      state.FillArray1[index].map(product => (
                        <option key={product.Id} value={product.Id}>
                          {product.Name}
                        </option>
                      ))}
                  </select>
                </td>
                <td>
                  <input
                    type="number"
                    name="Quantity"
                    value={row.Quantity}
                    onChange={e => handleRowChange(index, e)}
                    min="1"
                    className="form-control"
                    required
                  />
                </td>
                <td>
                  <button
                    type="button"
                    onClick={() => handleDeleteRow(index)}
                    className="btn btn-danger"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <button
          type="button"
          onClick={handleAddRow}
          className="btn btn-primary mt-3"
        >
          Add Row
        </button>

        <button type="submit" className="btn btn-success mt-3 ms-3">
          Submit
        </button>
      </form>
    </div>
  )
}

export default AddEdit_SalesPersonStock
